import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceUserSetupInsightsRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-user-setup-insights',
	path: '/jira/settings/system/performance/user-setup-insights/:dimension',
};
